import { MailOutlined } from '@ant-design/icons';
import { MailFilled } from '@ant-design/icons/lib/icons';
import { message } from 'antd';
import React from 'react';
import { LOG_OUT } from '../../constants';
import dashboardService from '../../services/dashboard.service';
import './index.css';
import i18n from 'i18next';
import AuthService from '../../services/auth.service';


export default class ServiceRow extends React.Component{


    constructor(props){
        super(props)
        this.state = this.props.data
    }

    handleMailActivation = (e) => {

        const target = e.currentTarget;

        const serviceName = target.parentElement.parentElement.getElementsByClassName("service-name")[0].innerHTML
        
        dashboardService.handleMailIfServiceIsDown(serviceName).then(
            response => {
                let success = response.data;
                if (success) {
                    var copystate = this.state
                    copystate.sendMailIfDown = !copystate.sendMailIfDown
                    this.setState(copystate)
                } else {
                    message.error(i18n.t('global_error'));
                }
            },
            error => {
                if (error.response && error.response.status === 401) {
                   
                } else {
                    message.error(i18n.t('service_mail_config_error'))
                }
            }
        )

    }

    render(){

        const service = this.props.data;
        const component = this.state.sendMailIfDown ? <MailFilled/> : <MailOutlined />


        return(

           <div className={'service-row ' + "service-"+service.status.toLowerCase()}>

                <p className='service-name'>{service.name}</p>
                <p className='service-status'>{service.status}</p>

                <div className='service-mail-div'>
                <button onClick={this.handleMailActivation} className={"service-mail"}>{component}</button>
                </div>

           </div>

        );
    }
}